var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.073994 16.037007",
    role: "img",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6b7280",
    d: "M1.987914.00127c-.326436-.0143-.634136.0926-.958081.30489-1.6643156 1.09051-1.3345746 2.54954 1.158586 5.13095l1.618506 1.67639-.785999 1.55752c-.931778 1.84584-.967454 2.32959-.238228 3.25665 1.083082 1.37691 2.799127.85425 3.821989-1.16427.765525-1.51069.631651-1.46789 2.518192-.80718.795321.27854 1.922157.59166 2.50424.69608 1.886355.33838 1.984375.46175 1.984375 2.49184v1.82366l.697115.54829c.924786.72744 1.828395.69238 2.622063-.10129l.649572-.64906v-1.84536-1.84537l1.521354-.31316c.836746-.17206 2.116667-.5376 2.844271-.81235 1.779899-.67209 1.749752-.68177 2.594157.82166 2.077755 3.69937 5.437262 1.80992 3.633887-2.04381l-.807703-1.72599 1.854151-1.9513 1.853633-1.95182v-.89607C31.074024 1.74691 30.307119.89662 29.16303.89662h-.920874L26.152361 3.03447C19.890238 9.4405 10.824392 9.359 4.790874 2.84224 3.515434 1.46465 2.706105.84588 1.987944.81446z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye_closed.9542e0442bfc0d1213abfe081fab7498.svg";
export { ForwardRef as ReactComponent };